export default __webpack_public_path__ + "static/media/close-icon-black.fde957f1.svg";